























































import {Component, Vue} from 'vue-property-decorator'
import {Getter, State, Mutation} from 'vuex-class'
import {Auth} from 'aws-amplify'

@Component
export default class Header extends Vue {

    @State('showLeftMenu')
    private showLeftMenu!: boolean

    @Getter getUserEmail!: string

    @Mutation
    setShowLeftMenu!: Function

    private get profile() {
        return this.$route.params.profile
    }

    private get tableName() {
        return this.$route.params.tableName
    }

    private onLeftMenuIconClick() {
        this.setShowLeftMenu(!this.showLeftMenu)
    }

    private async onLogoutClick() {
        try {
            await Auth.signOut();
            await this.$router.push({name: 'login'})
        } catch (error) {
            console.log('error signing out: ', error);
        }
    }

}
